const Shopee = {
  jobTitle: "Software Engineer Intern",
  company: "Shopee",
  duration: "May 2022 - Dec 2022",
  description:
    "Developed web features to for the Identity Verification to manage infrastructure and resources as a Front-End Engineer",
  jobscope: [
    "Developed and improved the overall UI/UX of the administrative web portal used by the Identity Verification Team",
    "Worked on repository migration for project expansion and documentation to onboard new developers",
    "Utilized Typescript, ReactJS and NodeJS in development",
  ],
  funFact:
    "The pantries and cafeteria were stacked with snacks and drinks like a shop when I interned there. There was a recreational area with a pool table, foosball table and a massage room too!",
};

export default Shopee;
